import { createSlice } from "@reduxjs/toolkit";

export const PhoneSlice = createSlice({
  name: "phone",
  initialState: {
    isHomePhoneInValid: null,
    isWorkPhoneInValid: null,
    isExtensionInValid: null,
    isPhoneChecked: false,
    homePhone: "",
    workPhone: "",
    isCheckedExtension: false,
    extension: "",
  },
  reducers: {
    changeIsPhoneChecked: (state, action) => {
      state.isPhoneChecked = action.payload;
    },
    changeHomePhone: (state, action) => {
      state.homePhone = action.payload;
    },
    changeWorkPhone: (state, action) => {
      state.workPhone = action.payload;
    },
    changeIsCheckedExtension: (state, action) => {
      state.isCheckedExtension = action.payload;
    },
    changeExtension: (state, action) => {
      state.extension = action.payload;
    },
    changeIsHomePhoneInValid: (state, action) => {
      state.isHomePhoneInValid = action.payload;
    },
    changeIsWorkPhoneInValid: (state, action) => {
      state.isWorkPhoneInValid = action.payload;
    },
    changeIsExtensionInValid: (state, action) => {
      state.isExtensionInValid = action.payload;
    },
  },
});

export const {
  changeIsPhoneChecked,
  changeHomePhone,
  changeWorkPhone,
  changeIsCheckedExtension,
  changeExtension,
  changeIsExtensionInValid,
  changeIsHomePhoneInValid,
  changeIsWorkPhoneInValid,
} = PhoneSlice.actions;
export default PhoneSlice.reducer;
